import { Button, CircularProgress } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useHistory } from 'react-router'
import When from 'src/components/When'
import useCanSave from 'src/hooks/useCanSave'
import { EntitySaver } from 'src/services/entitySaver'
import * as yup from 'yup'
import { Paper } from '../../../components'
import SelectInput from '../../../components/Formik/Forms/SelectInput'
import TextInput from '../../../components/Formik/Forms/TextInput'
import { MessagesYup } from '../../messages'
import { configuracoesRepository } from '../hooks/configuracoesRepository'
import { useConfiguracao } from '../hooks/useConfiguracao'
import { Configuracoes, tiposConfiguracao } from '../types'

const schema = yup.object().shape({
  chave: yup.string().trim().required(MessagesYup.MENSAGEM_OBRIGATORIO),
  valor: yup.string().trim().required(MessagesYup.MENSAGEM_OBRIGATORIO),
  tipo: yup.string().trim().required(MessagesYup.MENSAGEM_OBRIGATORIO)
})

const initialValues = {
  chave: '',
  valor: '',
  tipo: ''
}

export const ConfiguracoesForm = () => {
  const [configuracaoState] = useConfiguracao()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const canSave = useCanSave(configuracaoState, 'Configurações')

  async function handleSubmit(configuracao: Configuracoes) {
    setLoading(true)
    const formatConfiguracao = {
      id: configuracao.id,
      chave: configuracao.chave,
      valor: configuracao.valor,
      tipo: configuracao.tipo
    }
    await EntitySaver(
      () => configuracoesRepository.save(formatConfiguracao) as any,
      {
        onSuccess: () => handleGoBack(),
        feedbackError: 'Erro ao salvar Recursos'
      }
    )
    setLoading(false)
  }

  function handleGoBack() {
    const newPath = window.location.pathname.split('/')
    newPath.pop()
    history.replace(newPath.join('/'))
  }

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={
        configuracaoState.tag === 'with-data'
          ? configuracaoState.entity
          : initialValues
      }
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Paper>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <TextInput name="chave" label="Chave" disabled />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput name="valor" label="Valor" uppercase={false} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SelectInput
                  name="tipo"
                  label="Tipo"
                  options={tiposConfiguracao}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid
              justifyContent="flex-end"
              item
              container
              spacing={4}
              style={{ marginTop: 8 }}
            >
              <Grid item xs={12}>
                <Grid justifyContent="flex-end" container spacing={2}>
                  <Grid item style={{ width: 160 }}>
                    <Button
                      fullWidth
                      type="button"
                      variant="outlined"
                      onClick={handleGoBack}
                    >
                      Voltar
                    </Button>
                  </Grid>
                  <When value={canSave} equals>
                    <Grid item style={{ width: 160 }}>
                      <Button
                        data-testid="salvar"
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting || loading || !canSave}
                      >
                        {isSubmitting || loading ? (
                          <CircularProgress color="inherit" size={24} />
                        ) : (
                          'Salvar'
                        )}
                      </Button>
                    </Grid>
                  </When>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
      )}
    </Formik>
  )
}
